import { z } from 'zod'

export const etapaFormSchema = z.object({
  idcampeonato: z.number({ required_error: 'Campeonato obrigatorio' }).int().positive(),
  idmodalidade: z.number({ required_error: 'Modalidade obrigatoria' }).int().positive(),
  titulo: z.string().min(1, 'Titulo obrigatorio').max(150),
  titulo_reduzido: z.string().min(1, 'Titulo reduzido obrigatorio').max(50),
  temporada: z.number({ required_error: 'Temporada obrigatoria' }).int().min(2000),
  numero_etapa: z.number().int().min(1).max(6),
  data_inicio: z.string().min(1, 'Data obrigatoria'),
  data_encerramento: z.string().min(1, 'Data obrigatoria'),
  data_encerramento_inscricoes: z.string().min(1, 'Data obrigatoria'),
})

export type EtapaFormData = z.infer<typeof etapaFormSchema>
